module.exports = __webpack_public_path__ + "static/media/5-item-e.8171c762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/5-item-e.jpg
// module id = 1176
// module chunks = 33